import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import ReactPlaceholder from 'react-placeholder'

const useStyles = makeStyles(() => {
  return {
    root: {
      background: '#F2F2F2',
      paddingTop: 21,
      paddingBottom: 21
    },
    container: {
      paddingLeft: 69,
      paddingRight: 69,
      "@media only screen and (max-width: 1050px)": {
        paddingLeft: 20,
        paddingRight: 20
      }
    },
    title: {
      color: '#000',
      fontSize: 21,
      fontWeight: 'bold'
    },
    category: {
      color: '#BA0D59',
      fontWeight: 500
    }
  }
})

const TopicCardHeader = ({ categoryLabel, title, loading }) => {
  const classes = useStyles()
  return (
    <header className={classes.root}>
      <div className={classes.container}>
        <Typography className={classes.category}>
          {loading ? <ReactPlaceholder showLoadingAnimation ready={false} type="text" rows={1} /> : categoryLabel}
        </Typography>
        <Typography variant={'h1'} className={classes.title}>
          {title}
        </Typography>
      </div>
    </header>
  )
}
export default TopicCardHeader
